/**
 * Filter type options for booking exports.
 * Determines whether current filters are applied to the export.
 */
export default Object.freeze({
  /**
   * Export bookings with current filters applied.
   * Includes status, client, educator, and other active filters.
   */
  Filtered: 'filtered',

  /**
   * Export all bookings without applying current filters.
   * Only date range constraints are applied.
   */
  All: 'all',
})
